module.exports = __webpack_public_path__ + "assets/img/roof.bc770027.jpg";